import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FileValidationService, ValidationResult } from '../file-validation-service';
import { SUPPORTED_FILE_TYPES, MAX_FILE_SIZE } from '../../types/file-upload';
import { I18nService } from '@telecom/shared/services/i18n';
import { ToastError } from '@telecom/shared/utils/toast-error';

@injectable()
export class FileValidationServiceImpl implements FileValidationService {
    constructor(
        @inject(I18nService)
        private readonly _i18nService: I18nService,
    ) {}

    validateFile(file: File): ValidationResult {
        // 检查文件类型
        if (!SUPPORTED_FILE_TYPES.includes(file.type as any)) {
            const message = this._i18nService.t('fileValidationService.unsupportedFileType');
            throw new ToastError(message);
        }

        // 检查文件大小
        if (file.size > MAX_FILE_SIZE) {
            const message = this._i18nService.t('fileValidationService.fileSizeExceeded');
            throw new ToastError(message);
        }

        return { valid: true };
    }
}
